import { Injectable } from '@angular/core';
import { firstElement } from '@core/util/array';
import { GetItem, SetItem } from '@core/util/local-storage';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { AuthState } from '@state/auth';
import { orderBy } from 'lodash';

const MatterLastLocationKey = 'matterLastLocation';

interface MatterLastLocation {
	url: string;
	timeStamp: number;
	matterId: string;
}
type MatterLastLocations = { [id: string]: MatterLastLocation };

@Injectable({
	providedIn: 'root',
})
export class TrackLocationService {
	@SelectSnapshot(AuthState.getUserId) userId: string;

	setCurrentMatterLocation(matterId: string, url: string): void {
		const location: MatterLastLocation = {
			url,
			timeStamp: new Date().getTime(),
			matterId,
		};

		const orderedLocations = this.getAllSortedLocations();

		const firstTwenty = orderedLocations.slice(0, 20);
		const currentLocations = firstTwenty.reduce((prev, curr) => {
			prev[curr.matterId] = curr;

			return prev;
		}, {});

		currentLocations[matterId] = location;
		SetItem(this.getKey(), currentLocations);
	}

	getLastLocationForMatter(matterId: string): string {
		const locations = this.getAllLocations();

		if (!locations) {
			return null;
		}

		return locations[matterId]?.url;
	}

	getLastMatterLocation(): string {
		const orderedLocations = this.getAllSortedLocations();

		return firstElement(orderedLocations)?.url;
	}

	getAllLocations(): MatterLastLocations {
		return GetItem<MatterLastLocations>(this.getKey());
	}

	getAllSortedLocations(): MatterLastLocation[] {
		const locations = this.getAllLocations();

		if (!locations) {
			return [];
		}

		return orderBy(Object.values(locations), 'timeStamp', 'desc');
	}

	private getKey() {
		return `${this.userId}.${MatterLastLocationKey}`;
	}
}
